import { render, staticRenderFns } from "./SelectTransactionTypeDialog.vue?vue&type=template&id=5344d286&scoped=true&lang=pug&"
import script from "./SelectTransactionTypeDialog.vue?vue&type=script&lang=js&"
export * from "./SelectTransactionTypeDialog.vue?vue&type=script&lang=js&"
import style0 from "./SelectTransactionTypeDialog.vue?vue&type=style&index=0&id=5344d286&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5344d286",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VSpacer})
